export class ViewApplicationLocationZcConstants {
    static STEP_TITLE = "Location";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static OWNER_CONTROL = "owners";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    // static readonly VALIDATION_MESSAGES = {
    //   erfNo: {
    //     required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    //   },
    //   subdivision: {
    //     required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    //   },
    //   allotment: {
    //     required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    //   },
    //   farmNo: {
    //     required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    //   },
    //   sgCode: {
    //     required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    //   },
    //   address: {
    //     required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    //   },
    // }
    static PROPERTY_REQUIRED = "Please select a property before continuing with the create application process";
}
